import dayjs from 'dayjs';
import consts from '../consts';
import Model from '../models/model';
import util from '../util';
import { dataStore } from '../Store';


const isparametric = () => {
	const { auth } = dataStore.getState()
	const loadRelease = auth?.tags?.LoadReleaseId;
	return loadRelease === consts.LoadReleaseType.Parametric;
}
const { renderAttachmentButton } = util;
const checkIsNotParametric = () => !isparametric()
const model = new Model({
	name: 'Cycle',
	disableAdd: true,
	disableDelete: true,
	disableExport: false,
	defaultSort: 'CycleStart DESC',
	comboTypes: [{ "type": "CycleActionStatus", "loaded": true }, { "type": "CycleStatus", "loaded": true }, { "type": "Location", "loaded": true }, { "type": "EquipmentType", "loaded": true }, { "type": "Indicator", "loaded": true }, { "type": "TestOrControl", "loaded": true }],
	title: "Advantage Cycle",
	showGridRefreshBtn: true,
	headerFilterProps: {
		className: 'HeaderFilterForm'
	},
	columns: [
		{ field: 'CycleName', header: "CycleName", width: 200 },
		{ field: 'CycleCount', header: "CycleCount", width: 150, align:'right', headerAlign:'right' },
		{ field: 'CycleStatus', header: "CycleStatus", width: 200 },
		{ field: 'CycleStart', header: "CycleDateTime", type: 'dateTime', width: 200 },
		{ field: 'AlarmWarnings', header: "AlarmDescription", width: 150 },
		{ field: 'Label', header: "Label", width: 150, },
		{ field: 'InstrumentName', header: "Endoscope", width: 150, valueFormatter: util.removecommas },
		{ field: 'InstrumentSN', header: "EndoscopeId", width: 150, valueFormatter: util.removecommas },
		{ field: 'ModelNumber', header: "EndoscopeType", width: 150, valueFormatter: util.removecommas },
		{ field: 'OperatorName', header: "OperatorName", width: 150, valueFormatter: util.removecommas },
		{ field: 'UnloadOperatorName', header: "UnloadOperatorName", width: 150, valueFormatter: util.removecommas },
		{ field: 'UnloadOperatorID', header: "UnloadOperatorID", width: 150, valueFormatter: util.removecommas },
		{ field: 'AttachFile', header: "AttachFile", width: 150, renderCell: ({ row }) => (renderAttachmentButton(row)), filterable: false, isNotExportField: true },
		{ field: 'CycleActionStatus', header: "ReviewStatus", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewComment', header: "Comment", width: 150, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewDate', header: "ApprovedOn", width: 150, type: 'dateTime', isLocal: true, excludeOnGrid: checkIsNotParametric },
		{ field: 'ReviewByUser', header: "ApprovedBy", width: 150, excludeOnGrid: checkIsNotParametric },
		{
			field: 'startDate',
			header: 'Start Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			filterable: false,
			maxDate: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : undefined),
			hidden: true
		},
		{
			field: 'endDate',
			header: 'End Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			minDate: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			hidden: true
		}
	]
});
export const AdvantageCycleModel = model;
export default model.createFormBase();